export const KEY = 'lib_contact'
